function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24.848,
    viewBox: "0 0 25 24.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 77819"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26127",
    d: "M109.17 220.45a12.5 12.5 0 0 1-10.546 12.35v-8.735h2.911l.556-3.613h-3.467V218.1a1.807 1.807 0 0 1 2.037-1.952h1.576v-3.076a19.219 19.219 0 0 0-2.8-.244c-2.856 0-4.722 1.731-4.722 4.863v2.756h-3.173v3.613h3.174v8.74a12.5 12.5 0 1 1 14.454-12.35z",
    transform: "translate(-84.17 -207.95)",
    style: {
      fill: "#518ef8"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcn);
export default __webpack_public_path__ + "static/media/facebook-icn.71b21e1fd0ea316b749a591dff114623.svg";
export { ForwardRef as ReactComponent };